import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import { TextArea } from "lib/core/components/forms"
import PropTypes from "prop-types"
import "./styles/StepCommentField.css"

const charLimit = 250

const StepCommentField = function ({ required, comment, onChange }, { user }) {
  let label = "Leave a comment"
  if (required) {
    label += " (Required)"
  }

  return (
    <div className="StepCommentField">
      <h6>{label}</h6>
      <div className="StepCommentField__input">
        <Avatar user={user} size="30px" />
        <TextArea
          id="StepCommentField"
          placeholder="Leave a private comment for your teacher or moderator..."
          value={comment}
          onChange={onChange}
          showError={(comment != null ? comment.length : undefined) > charLimit}
          errorMessage="Max 250 chars."
          inline={true}
        />
      </div>
    </div>
  )
}

StepCommentField.displayName = "StepCommentField"

StepCommentField.contextTypes = { user: PropTypes.object }

export default StepCommentField
